import axiosClient from './axiosClient'

export const packageApi = {
  getDurationPackages: (params) => {
    const url = '/package/get-duration-packages'
    return axiosClient.get(url, { params })
  },
}
